import { CRISIS_RESOURCES } from '@lessalone/shared';

/**
 * The crisis resources, surfaced wherever a self-harm signal appears.
 *
 * Each resource exposes an immediate action (`href` — `tel:988` or
 * `sms:741741`) and a learn-more URL. The action link lets a user
 * one-tap to call or text from a phone instead of copying a number
 * — friction at a crisis moment is the worst kind of friction. The
 * details/URL stay visible so the surface still reads as informational
 * even when the user isn't going to tap.
 */
export function CrisisResources() {
  return (
    <ul className="crisis-list">
      {CRISIS_RESOURCES.map((resource) => (
        <li key={resource.name}>
          <strong>{resource.name}</strong> —{' '}
          <a className="crisis-action" href={resource.href}>
            {resource.detail}
          </a>
          {' · '}
          <a href={resource.url} target="_blank" rel="noreferrer">
            {resource.url.replace('https://', '')}
          </a>
        </li>
      ))}
    </ul>
  );
}
